<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hbphEt/tc-custom/9781609250010.jpg?1718072593922" alt="This image is the cover for the book Attitudes of Gratitude"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Attitudes of Gratitude
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“This little book is an elixir for the soul . . . we can change our lives by changing our thoughts—what a miracle!” —Kathy Freston, </b><b><i>New York Times</i></b><b>–bestselling author of </b><b><i>Quantum Wellness</i></b><br/>  <br/> In <i>Attitudes of Gratitude</i>, M. J. Ryan teaches readers how to unlock the fullness of their hearts and lives through the expression of gratitude. “Gratitude helps us to return to our natural state of joyfulness,” she writes, “where we notice what’s right instead of what’s wrong. It makes us feel complete, that we have everything we need, at least in this moment.”<br/>  <br/> In her introduction to this 10th anniversary edition, Ryan recounts current research that bolsters her original thinking—people who practice gratitude on a daily basis are, by and large, happier, healthier, and more effective in the world. She also shares with readers brand new, top-10 gratitude practices, which readers of the first edition and people she’s taught and counseled over the years have provided to her. The concept of this book is very simple and very profound: “Gratitude creates happiness.” It’s a fact of life (and science as it turns out).<br/>  <br/><b>“This inspiring book shows us how to rejoice in what we have . . . Ryan graciously shows that if we’re going to ‘have an attitude,’ gratitude is the right one.” —Paul Pearsall, PhD, <i>New York Times</i>-bestselling author of <i>The Heart’s Code</i></b><br/>  <br/><b>“Exquisitely reconnects us to the wonder and satisfaction that can be found in our daily lives.” —Judy Ford, author of <i>Wonderful Ways to Love a Teen</i></b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        M. J. Ryan
      </h2>
      
      <p class="authorDescription body article"><B><P>M.J. Ryan is an inspirational speaker and human development expoert, and author of several bestselling books including <I>This Year I Will…</I>, <I>The Happiness Makeover: How to Teach Yourself to Be Happy and Enjoy Every Day</I> and <I>Attitudes of Gratitude</I>. She lives in the San Francisco Bay area with her family.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Conari Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6373c77c